// extracted by mini-css-extract-plugin
module.exports = {"Blog":"BlogCards_Blog__vZz9e","BlogDes":"BlogCards_BlogDes__1xvbk","idTab":"BlogCards_idTab__25cse","ImgBlog":"BlogCards_ImgBlog__2IyDh"};